import { render, staticRenderFns } from "./Statistics2.vue?vue&type=template&id=107d1752&scoped=true&"
import script from "./Statistics2.vue?vue&type=script&lang=js&"
export * from "./Statistics2.vue?vue&type=script&lang=js&"
import style0 from "./Statistics2.vue?vue&type=style&index=0&id=107d1752&prod&scoped=true&lang=css&"
import style1 from "./Statistics2.vue?vue&type=style&index=1&id=107d1752&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d1752",
  null
  
)

export default component.exports